module.exports = __webpack_public_path__ + "5d4ed7559b2773227caebd76c4fc5271.svg";